import React, { useState, useEffect } from 'react';
import './Navbar.css';
import main_logo from '../../assets/main_logo.svg';
import { AiOutlineMenu } from 'react-icons/ai';
import axios from 'axios';
import { baseUrl } from '../../Global/GlobalVariable';
import { BiSearchAlt2 } from 'react-icons/bi';
import $ from 'jquery';
import { Navbar, Container, Nav, NavDropdown, Dropdown } from 'react-bootstrap';
import { baseVar } from '../../Global/GlobalVariable';

function Navbars({ data }) {
	const [selectedOption, setSelectedOption] = useState(null);
	const [showMenu, setShowMenu] = useState(false);
	const [showMenu2, setShowMenu2] = useState('');
	const handleMouseOver = () => {
		setShowMenu(true);
	};

	const handleMouseOut = () => {
		setShowMenu(false);
	};
	const handleNav = () => {
		if (showMenu2 === '') {
			setShowMenu2('show');
		} else if (showMenu2 === 'show') {
			setShowMenu2('');
		}
	};

	const searchInput = async (e) => {
		let value = e.target.value;
		if (value) {
			$('.has-megamenu').hide();
		} else {
			$('.has-megamenu').show();
		}
		await axios
			.get(`${baseUrl}/GetSearchServicesList?search=${value}`)
			.then((res) => {
				setSelectedOption(res.data);
			});
	};

	$('.popup_model_onScrollnv').addClass('popup_model_onScroll_bgnv');

	const scrollFn = () => {
		$('.popup_model_onScrollnv').removeClass('popup_model_onScroll_bgnv');
		setTimeout(fadeInFn, 1000);
	};
	const fadeInFn = () => {
		$('.popup_model_onScrollnv').addClass('popup_model_onScroll_bgnv');
	};
	return (
		<div className=''>
			<Navbar
				className='navbar navbar-expand-lg navbar-white py-2 p-0 d-block d-lg-none '
				bg='white'
				expand='lg'>
				<Container className='px-2'>
					<a
						title='private Limited company registration'
						className='navbar-brand me-lg-5 pe-lg-5'
						href={baseVar}>
						<img
							src={
								'https://admin.eauditoroffice.com/public/assets/images/e-auditor-logo.png'
							}
							alt='private Limited company registration'
							width='142'
							height='17'
							title='private Limited company registration'
						/>
					</a>

					<Navbar.Toggle aria-controls='basic-navbar-nav border-0 p-0' className='bg-white'/>
					<Navbar.Collapse id='basic-navbar-nav'>
						<Nav className='me-auto'>
							<div
								className='navbar-nav'
								style={{ width: '100%', justifyContent: ' space-between' }}>
								<div className='dropdown dropDown_scroll mt-3 '>
									<div id='myDropdown' className='dropdown-content m-1'>
										<input
											type='text'
											placeholder='Search..'
											id='myInput'
											onChange={searchInput}
										/>
										<i>
											<BiSearchAlt2 />
										</i>
										{selectedOption?.map((res, i) => {
											return (
												<a
													key={i}
													href={baseVar + '/' + res.service_url}
													title={baseVar + '/' + res.service_url}
													className='py-2 my-2 text-start text-decoration-none nav-link text-capitalize'>
													{res.service_name}
												</a>
											);
										})}
									</div>
								</div>
								{data.map((res, i) => {
									return (
										<NavDropdown
											key={i}
											className='has-megamenu'
											title={res.service_head_name}
											id='basic-nav-dropdown'>
											<div className=' megamenu_card pt-4'>
												{res.service_list_group.map((res, i) => {
													return (
														<div
															key={i}
															className='col-12 col-lg-4 col-md-6 mb-3'>
															<div className=''>
																<h3 className='popup-title p-2 mb-4  px-lg-3'>
																	{res.service_group}
																</h3>

																<div className='popup-uls ps-3'>
																	{res.submenu.map((res, i) => {
																		return (
																			<a
																				key={i}
																				title={res.service_name}
																				className=' text-decoration-none text-dark text_hover '
																				href={baseVar + '/' + res.service_url}>
																				{res.service_name}
																			</a>
																		);
																	})}
																</div>
															</div>
														</div>
													);
												})}
											</div>
										</NavDropdown>
									);
								})}
								<NavDropdown
									className='has-megamenu'
									title='eAuditor Office'
									id='basic-nav-dropdown'>
									<div className=' megamenu_card pt-4'>
										<div className='col-12 col-lg-4 col-md-6 mb-3'>
											<div className=''>
												<div className='popup-uls ps-3'>
													<a
														className='text-decoration-none text-dark text_hover '
														href={baseVar + '/about-us'}
														title='About us'>
														About us
													</a>
													<a
														className='text-decoration-none text-dark text_hover '
														href={baseVar + '/blog'}
														title='Blog'>
														Blog
													</a>
													<a
														className='text-decoration-none text-dark text_hover '
														href={baseVar + '/contact-us'}
														title='Contact Us'>
														Contact Us
													</a>
												</div>
											</div>
										</div>
									</div>
								</NavDropdown>
							</div>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>

			<nav className=' navbar navbar-expand-lg navbar-dark p-0  d-none d-lg-block '>
				<div className='container' style={{ height: '80px' }}>
					<div className='col-2'>
						<a
							title='private Limited company registration'
							className='navbar-brand me-lg-5 pe-lg-5 py-4'
							href={baseVar}>
							<img
								src={
									'https://admin.eauditoroffice.com/public/assets/images/e-auditor-logo.png'
								}
								alt='private Limited company registration'
								width='142'
								height='17'
								title='private Limited company registration'
							/>
						</a>
					</div>
					<div className='col-10 '>
						<div className='eauditor-menu-area'>
							<div className='main-menu'>
								<nav className='eauditor-menu l  md-pr-0 eauditor-menu-close'>
									<ul className='nav-menu menu-icon-responsive'>
										{data.map((res, i) => {
											return (
												<li
													key={i}
													className='eauditor-mega-menu menu-item-has-children '>
													<div
														title={res.service_head_name}
														className='dropdown-toggle mb-0'
														data-bs-toggle='dropdown'>
														{res.service_head_name}
													</div>
													<ul
														className='mega-menu mobilemenuscroll'
														style={{ left: '0' }}>
														<li className='mega-menu-container  mt-3'>
															<div className='mega-menu-innner'>
																<div className='single-megamenu menu-links-u'>
																	<ul
																		className={
																			'sub-menu  ' +
																			(res.service_list_group.length === 3 &&
																				'custom_minWidth  ') +
																			' ' +
																			(res.service_list_group.length === 2 &&
																				'custom_minWidth_two  ') +
																			' popup_model_onScrollnv popup_model_onScroll_bgnv'
																		}
																		onMouseOver={scrollFn}>
																		{res.service_list_group.map((res, i) => {
																			return (
																				<li key={i} className=''>
																					<h4 className='popup-title '>
																						<span> {res.service_group}</span>
																					</h4>
																					{res.submenu.map((res, i) => {
																						return (
																							<p
																								key={i}
																								className='popup-uls ps-3'>
																								<a
																									title={res.service_name}
																									className='text-decoration-none text-dark text_hover '
																									href={
																										baseVar +
																										'/' +
																										res.service_url
																									}>
																									{res.service_name}
																								</a>
																							</p>
																						);
																					})}
																				</li>
																			);
																		})}

																		<div className='sub-menu-close'>
																			<i
																				className='fa fa-times'
																				aria-hidden='true'></i>
																			Close
																		</div>
																	</ul>
																</div>
															</div>
														</li>
														<div className='sub-menu-close'>
															<i className='fa fa-times' aria-hidden='true'></i>
															Close
														</div>
													</ul>
													<span className='eauditor-menu-parent'>
														<i
															className='fa fa-angle-down'
															aria-hidden='true'></i>
													</span>
													<span className='eauditor-menu-parent'>
														<i
															className='fa fa-angle-down'
															aria-hidden='true'></i>
													</span>
												</li>
											);
										})}
										<div
											className='eauditor-mega-menu'
											onMouseOver={handleMouseOver}
											onMouseOut={handleMouseOut}>
											<Dropdown id='dropdown_nvb'>
												<div
													title='eaditor office'
													className='dropdown-toggle'
													data-bs-toggle='dropdown'
													onClick={handleNav}
													onMouseOver={handleMouseOver}
													onMouseOut={handleMouseOut}>
													eAuditor Office
												</div>

												<Dropdown.Menu
													show={showMenu}
													className={showMenu2 + ' ' + 'custom_dropdown_menu '}>
													<div href='#/action-1'>
														<p className='popup-uls '>
															<a
																title='About Us'
																className='text-decoration-none text-dark text_hover '
																href={baseVar + '/about-us'}>
																About Us
															</a>
														</p>
													</div>
													<div>
														<p className='popup-uls '>
															<a
																title='blog'
																className='text-decoration-none text-dark text_hover '
																href={baseVar + '/blog'}>
																Blog
															</a>
														</p>
													</div>
													<div>
														<p className='popup-uls '>
															<a
																title='Contact Us'
																className='text-decoration-none text-dark text_hover '
																href={baseVar + '/contact-us'}>
																Contact Us
															</a>
														</p>
													</div>
												</Dropdown.Menu>
											</Dropdown>
										</div>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</nav>
		</div>
	);
}

export default Navbars;
